import utils from '../utils';
//import customStyle from './map-style';

var mapInstance;

function initGoogleMap() {
	let map = document.querySelector('#gmap');
	if (map) {
		var apiKey = map.getAttribute('data-api');
		utils.loadScript('https://maps.googleapis.com/maps/api/js?key=' + apiKey, false, function () {
			startMap(map);
		});
	}
}

function startMap(map) {
	let
		latitude = Number(map.getAttribute('data-ltd')),
		longitude = Number(map.getAttribute('data-lng')),
		link = Number(map.getAttribute('data-link')),
		zoom = 15,
		maxZoom = 16,
		latLng = new window.google.maps.LatLng(latitude, longitude);

	mapInstance = new window.google.maps.Map(map, {
		center: latLng,
		zoom,
		styles: 'terrain', //customStyle,
		disableDefaultUI: true,
	});

	let marker = {
		google: new window.google.maps.Marker({
			position: latLng,
			map: mapInstance,
			icon: {
				url: window.baseUrl + '/images/map-marker.svg', //TODO: set assets path
				scaledSize: new window.google.maps.Size(100, 100),
			},
		}),
	};
	
	marker.google.addListener("click", () => {
		return function () {
			window.open(link);
		}
	});


	mapInstance.setOptions({ maxZoom });

}

export default { initGoogleMap };